import { QueryFunctionContext } from '@tanstack/react-query';

import { baseQuery } from '../baseQuery';
import { Technician } from 'types';

type getTechnicianParams = {
  technicianId?: string;
};

export const getTechnician = async ({ queryKey }: QueryFunctionContext<[string, getTechnicianParams]>) => {
  const [, params] = queryKey;
  const { data } = await baseQuery(`technicians/${params.technicianId}`);

  return data as Technician;
};
